<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md4>
				<v-date-picker
					ref="picker"
					v-model="date"
					full-width
					:min="min"
					:show-current="true"
					:picker-date.sync="date"
					year-icon="mdi-calendar-blank"
					prev-icon="mdi-skip-previous"
					next-icon="mdi-skip-next"
				>
				</v-date-picker>
			</v-flex>
			<v-flex xs12 md8>
				<v-card flat color="transparent">
					<v-card-title primary-title>
						{{ $t("title.shifts") }}
						<v-spacer></v-spacer>
						<v-select
							:items="outlets"
							v-model="outlet_uuid"
							:label="$t('label.outlet')"
							item-value="uuid"
							item-text="name"
						></v-select>
					</v-card-title>
					<v-card-text class="py-0">
						<v-simple-table>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">
											{{ $t("Status") }}
										</th>
										<th class="text-left">
											{{ $t("Name") }}
										</th>
										<th class="text-left">
											{{ $t("label.time_start") }}
										</th>
										<th class="text-left">
											{{ $t("label.time_end") }}
										</th>
										<th class="text-left">
											{{ $t("label.time_interval") }}
										</th>
										<th class="text-left">
											{{ $t("label.pax_min") }}
										</th>
										<th class="text-left">
											{{ $t("label.pax_max") }}
										</th>
										<th class="text-left">
											{{ $t("label.pax_total") }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(item, index) in items"
										:key="index"
									>
										<td>
											<v-switch
												v-model="item.status"
												@change="changeStatus(item)"
											>
											</v-switch>
										</td>
										<td>{{ item.name }}</td>
										<td>{{ item.time_start }}</td>
										<td>{{ item.time_end }}</td>
										<td>{{ item.time_interval }}</td>
										<td>{{ item.pax_min }}</td>
										<td>{{ item.pax_max }}</td>
										<td>{{ item.pax_total }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import moment from "moment";
export default {
	props: ["items", "outlets", "outlet", "selected_date"],

	data() {
		return {
			date: this.selected_date ?? new moment().format("YYYY-MM-DD"),
			outlet_uuid: this.outlet,
			item: this.$inertia.form({}),
		};
	},
	computed: {
		min() {
			return new moment().format("YYYY-MM-DD");
		},
	},
	watch: {
		date: {
			async handler() {
				if (this.outlet_uuid && this.date) {
					await this.getItems();
				}
			},
			immediate: true,
		},
		outlet_uuid: {
			async handler() {
				if (this.outlet_uuid && this.date) {
					await this.getItems();
				}
			},
			immediate: true,
		},
	},

	methods: {
		async getItems() {
			try {
				await this.$inertia.reload({
					only: ["items"],
					data: { outlet_uuid: this.outlet_uuid, date: this.date },
				});
			} catch (error) {
				this.$toast.error(error.message);
			}
		},

		async changeStatus(item) {
			try {
				this.item = this.$inertia.form({
					disabled: !item.status,
					date: this.date,
					reservation_shift_id: item.id,
				});
				await this.item.post(
					this.$route("tenant.reservation_availability.store", {
						tenant: this.$page.props.tenant.id,
					})
				);
			} catch (error) {
				this.$toast.error(error.message);
			}
		},
	},
};
</script>